import React, { PureComponent } from 'react';

import { Paper, Table, TableHead, TableBody, TableRow, TableCell, 
  Toolbar, Typography,} from '@material-ui/core';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    maxWidth: 1060,
    margin: 'auto',
  },
  toolbar: {
    paddingRight: theme.spacing.unit,
  },
  spacer: {
    flexGrow: 1,
  },
  title: {
    flex: '0 0 auto',
  },
  tablerow: {
    height: 36
  },
});

class YTDSummary extends PureComponent {

  componentDidMount(){
    this.props.getYtdSummaryData();
  }

  formatPercent = fraction => {
    return Math.round(fraction*1000)/10 + "%";
  }

  render() {
    const { fetchingYtdSummaryDataStatus } = this.props;
    const { classes } = this.props;

    return (
      <Paper className={classes.root}>
        <Toolbar className={classes.toolbar}>
          <div  className={classes.title}>
            <Typography variant="h5">
              YTD Summary
            </Typography>
          </div>
            <div className={classes.spacer} />
        </Toolbar>
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell padding="dense"><Typography variant="body1">Season</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Total Games</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Umpires Requested</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Umpires Filled</Typography></TableCell>
              <TableCell align="center"><Typography variant="body1">Filled by Guardians</Typography></TableCell>        
              <TableCell align="center"><Typography variant="body1">Filled by Non-Guardians</Typography></TableCell>        
            </TableRow>
          </TableHead>
          {fetchingYtdSummaryDataStatus === 'Loaded' && this.renderTableBody()}
        </Table>
      </Paper>
    );
  }

  renderTableBody() {
    const { reportSeasons, reportSeasonsList } = this.props;
    const { classes } = this.props;
  
    return (
      <TableBody>
      {reportSeasonsList.map((seasonId) => {
        const season = reportSeasons[seasonId];
        const umpsReqTotal = season.umpsReqTotal === 0 ? 1 : season.umpsReqTotal;
        return (
          <TableRow className={classes.tablerow} key={seasonId} hover>
            <TableCell padding="dense"><Typography variant="body1">{season.seasonName}</Typography></TableCell>
            <TableCell align="center"><Typography variant="body1">{season.totalGames}</Typography></TableCell>
            <TableCell align="center"><Typography variant="body1">{season.umpsReqTotal}</Typography></TableCell>
            <TableCell align="center"><Typography variant="body1">
              {season.umpsFilledTotal} ({this.formatPercent(season.umpsFilledTotal/umpsReqTotal)})
            </Typography></TableCell>
            <TableCell align="center"><Typography variant="body1">
              {season.guardiansFilled} ({this.formatPercent(season.guardiansFilled/umpsReqTotal)})
            </Typography></TableCell>        
            <TableCell align="center"><Typography variant="body1">
              {season.nonGuardiansFilled} ({this.formatPercent(season.nonGuardiansFilled/umpsReqTotal)})
            </Typography></TableCell>        
          </TableRow>
        );
      })}
      </TableBody>
    ); 
  };
};


YTDSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(YTDSummary);



// WEBPACK FOOTER //
// ./src/components/YTDSummary.js